<template>
  <li
    :class="{
      'cursor-not-allowed': option.customFields?.blocked_for_customer,
      'cursor-pointer': !option.customFields?.blocked_for_customer,
    }"
    @click="onClick"
  >
    <div
      v-if="option.media"
      class="h-full rounded-sm border p-2 text-center hover:bg-gray-10"
      :class="{
        'border-gray-500 bg-gray-10': selected,
        'border-transparent': !selected,
      }"
    >
      <ShopSharedImage :media="option.media" class="mx-auto rounded-full" />
      <span
        class="mt-2 inline-block text-2xs"
        :class="{
          'font-bold': selected,
          'font-medium': !selected,
        }"
      >
        {{ getTranslatedProperty(option, 'name') }}
      </span>
    </div>
    <div
      v-else
      class="rounded-sm border px-4 py-2 text-xs font-semibold"
      :class="{
        'border-gray-500 bg-gray-500 text-white': selected,
        'border-gray-500 bg-white text-gray-500':
          !selected && option.customFields?.combinable,
        'border-gray-300 bg-white text-gray-200':
          !option.customFields?.combinable && !selected,
        'border-gray-100 bg-gray-100 text-gray-200': blocked,
      }"
    >
      <span class="text-2xs leading-none">
        {{ getTranslatedProperty(option, 'name') }}
      </span>
    </div>
  </li>
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'
import type { Schemas } from '#shopware'

const props = defineProps<{
  option: Schemas['PropertyGroup']
}>()

const emit = defineEmits(['change'])

const { getSelectedOptions } = useProductConfigurator()

const selected = computed(() =>
  Object.values(getSelectedOptions.value).includes(props.option.id)
)

const blocked = computed(
  () => !!props.option.customFields?.blocked_for_customer
)

const onClick = () => {
  if (!blocked.value) {
    emit('change', props.option.id)
  }
}
</script>
